import moment from 'moment';

import { isDateValid } from '@elab/core/utils/DateUtils';

const validDate = date => (date ? isDateValid(date) : true);

const pastOrPresent = date => {
    if (!date) return true;

    return isDateValid(date) && moment(date).isSameOrBefore(moment());
};

const dateRange = (date, _, parameters) => {
    if (!date) return true;

    let isValid = isDateValid(date);

    if (isValid && parameters && parameters.min) {
        isValid = moment(date).isSameOrAfter(parameters.min);
    }

    if (isValid && parameters && parameters.max) {
        isValid = moment(date).isSameOrBefore(parameters.max);
    }

    return isValid;
};

const ageVerification = (date, _, parameters) => {
    const startRange = moment().subtract(parameters.max, 'years');
    const endRange = moment().subtract(parameters.min, 'years');

    return moment(date).isBetween(startRange, endRange);
};

export default {
    validDate,
    pastOrPresent,
    dateRange,
    ageVerification,
};
